import React from 'react';
import PropTypes from 'prop-types';
import { colors, Adaptive, Text, Grid } from '@custom-components';
import {
  StyledProgressItem,
  StyledSVGIcon,
  StyledPara,
  StyledBar,
  StyledArrowSVGIcon,
  StyledBackButton,
  StyledMobileContainer,
  BackSVGIcon,
  StyledHeadingFourth,
  StyledSubHeadingFifth,
  ProgressBarContainer,
  StyledButton
} from '../Steps.styles';

function ProgressBar(props) {
  const { progressItems, step, heading, subheading, backButtonText, onBackClick, hideBackButton } = props;
  const itemWidth = 100 / progressItems.length;
  const barWidth = itemWidth * step;

  return (
    <ProgressBarContainer>
      <Grid.Container>
        {!hideBackButton && (
          <Grid.Visible lg xl>
            <StyledBackButton type="button" onClick={onBackClick}>
              <BackSVGIcon selectedIcon="searchArrow" iconColor={colors.colorBlue} />{' '}
              <Text.CopyMini textTransform="uppercase" tagName="span" color="quaternary">
                {backButtonText}
              </Text.CopyMini>
            </StyledBackButton>
          </Grid.Visible>
        )}

        <StyledHeadingFourth>{heading}</StyledHeadingFourth>
        {subheading.length > 0 && <StyledSubHeadingFifth>{subheading}</StyledSubHeadingFifth>}
        <StyledBar barWidth={barWidth} />

        <Adaptive
          sm={
            <StyledMobileContainer>
              {!hideBackButton && (
                <StyledBackButton type="button" onClick={onBackClick}>
                  <StyledArrowSVGIcon selectedIcon="searchArrow" iconColor={colors.colorBlue} />
                </StyledBackButton>
              )}
              <StyledPara color="quaternary" weight="bold" align="center">
                {progressItems[step - 1].label}
                {` (${step}/${progressItems.length})`}
              </StyledPara>
            </StyledMobileContainer>
          }
          lg={progressItems.map((item, index) => (
            <StyledProgressItem key={item.label} width={itemWidth} step={step}>
              {index + 1 < step && <StyledSVGIcon selectedIcon="checkmark" iconColor={colors.colorGrey03} />}
              <StyledPara weight="bold" color={index + 1 === step ? 'quaternary' : 'tertiary'}>
                {index + 1 < step ? (
                  <StyledButton type="button" onClick={item.onClick}>
                    {item.label}
                  </StyledButton>
                ) : (
                  <>{item.label}</>
                )}
              </StyledPara>
            </StyledProgressItem>
          ))}
        />
      </Grid.Container>
    </ProgressBarContainer>
  );
}
ProgressBar.propTypes = {
  /** Array of step names and onClick functions  */
  progressItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func
    })
  ),
  /** Current step # */
  step: PropTypes.number,
  /** Heading that displays above progress */
  heading: PropTypes.string,
  /** Subheading that displays below heading */
  subheading: PropTypes.string,
  /** Text on back button on lg/xl */
  backButtonText: PropTypes.string,
  /** Hide the back button */
  hideBackButton: PropTypes.bool,
  /** onClick function to route user */
  onBackClick: PropTypes.func
};

ProgressBar.defaultProps = {
  progressItems: [],
  step: 1,
  heading: 'Complete your booking',
  subheading: '',
  backButtonText: 'Back',
  hideBackButton: false,
  onBackClick: () => {}
};

export default ProgressBar;
